import { withHTMLComponent } from '@updater-legacy/components/custom-element';

const tpl = `
  <slot></slot>
`;

const styles = `
    :host {
      border-radius: 1.458333em;
      font-size: 0.75em;
      background-color: #56b784;
      color: white;
      display: inline-block;
      font-weight: 300;
      padding: .25em 1em;
    }
`;

class Chip extends withHTMLComponent(styles, tpl)() {}

customElements.define('upd-home-security-chip', Chip);
